import * as React from 'react';
import { useState } from 'react';
import { Swiper as SwiperType, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Color, DirectionEnum, IconName } from '../../enums';
import { Quote } from '../../interfaces';
import { UseState } from '../../types';
import { highlightTextFragments, toMarkdown } from '../../utils';
import { swiperSlideTag } from '../swiperSlideElement/swiperSlideElement.component';

import GreenPattern from './images/greenPattern.svg';
import {
  Author,
  AuthorSpecialty,
  Container,
  TextContent,
  QuoteText,
  Content, 
  ArrowButton,
  DotsContainer,
  Dot,
  CircleBackgroundItem,
  ContainerInsideSlider,
  StyledIcon,
  SwiperContainer,
} from './quoteCarousel.styled';
import { QuoteCarouselProps } from './quoteCarousel.types';

export const QuoteCarousel: React.FC<QuoteCarouselProps> = (props: QuoteCarouselProps) => {
  const { quotes, className }: QuoteCarouselProps = props;
  const [swiperInstance, setSwiperInstance]: UseState<SwiperType | null> = useState<SwiperType | null>(null);
  const [activeIndex, setActiveIndex]: UseState<number> = useState<number>(0);
  SwiperType.use([Autoplay]);

  return (
    <Container className={className}>
      <CircleBackgroundItem src={GreenPattern} alt='' />
      <Content>
        {swiperInstance && quotes.length > 1  && (
          <ArrowButton onClick={(): void =>swiperInstance.slidePrev()} $position={DirectionEnum.Left}>
            <StyledIcon
              name={IconName.ArrowLeft25}
              size={24}
              color={Color.White}
              $position={DirectionEnum.Left}
            />
          </ArrowButton>
        )}
        <SwiperContainer>
          <Swiper
            onSwiper={setSwiperInstance}
            onSlideChange={(swiper: SwiperType): void => setActiveIndex(swiper.realIndex)}
            speed={600}
            spaceBetween={0}
            slidesPerView={1}
            centeredSlides={true}
            autoplay={quotes.length > 1
              ? { delay: 5000, disableOnInteraction: false }
              : false
            }
            loop={quotes.length > 1}
          >
            {quotes.map((quote: Quote): JSX.Element => (
              <SwiperSlide key={quote.content} tag={swiperSlideTag} style={{ display: 'flex', alignSelf: 'center' }}>
                <ContainerInsideSlider>
                  <TextContent key={quote.content}>
                    <QuoteText
                      dangerouslySetInnerHTML={{
                        __html: toMarkdown(highlightTextFragments(quote.content))
                      }}
                      $hasSmallerFont={quote.content.length > 60} 
                    />
                    {!!quote.author && <Author>{quote.author}</Author>}
                    {!!quote.authorSpecialty && <AuthorSpecialty>{quote.authorSpecialty}</AuthorSpecialty>}
                  </TextContent>
                </ContainerInsideSlider>
              </SwiperSlide>
            ))}
          </Swiper>
          {swiperInstance && quotes.length > 1  && (
            <DotsContainer>
              {quotes.map((quote: Quote, index: number): JSX.Element => (
                <Dot
                  $isActive={index === activeIndex}
                  key={quote.content}
                  onClick={(): void => swiperInstance.slideTo(index + 1)}
                />
              ))}
            </DotsContainer>
          )}
        </SwiperContainer>
        {swiperInstance && quotes.length > 1  && (
          <ArrowButton onClick={(): void => swiperInstance.slideNext()} $position={DirectionEnum.Right}>
            <StyledIcon
              name={IconName.ArrowRight25}
              size={24}
              color={Color.White}
              $position={DirectionEnum.Right}
            />
          </ArrowButton>
        )}
      </Content>
    </Container>
  );
};
